export const getDeviceType = (width) => {
  if (width > 1200) return 'desktop';
  if (width > 768) return 'tablet';
  return 'mobile';
};
